import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Phone, MessageCircle, CalendarDays } from "lucide-react";
import { company } from "@/data/site";
import { TerminDialog } from "@/components/TerminDialog";

export const QuickContact = () => {
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    const on = () => setShow(window.scrollY > 240);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  if (!show || pathname === "/termin") return null;

  const items = [
    { label: "Anrufen", href: company.phoneHref, Icon: Phone, id: "quick-call" },
    { label: "WhatsApp", href: company.whatsapp, Icon: MessageCircle, id: "quick-whatsapp", ext: true },
  ];

  return (
    <div data-testid="quick-contact-bar" className="reveal-up lg:hidden fixed bottom-4 inset-x-4 z-30">
      <div className="grid grid-cols-3 rounded-xl bg-[rgba(20,19,24,0.92)] border hairline backdrop-blur-xl text-[color:var(--ink)] shadow-[0_10px_40px_rgba(0,0,0,0.45)] p-1.5">
        {items.map(({ label, href, Icon, id, ext }) => (
          <a key={id} href={href} data-testid={id} target={ext ? "_blank" : undefined} rel={ext ? "noreferrer" : undefined} className="flex items-center justify-center gap-2 h-12 rounded-lg text-sm hover:bg-white/5 transition-colors">
            <Icon className="h-4 w-4" strokeWidth={1.75} /> {label}
          </a>
        ))}
        <TerminDialog testId="quick-appointment" className="flex items-center justify-center gap-2 h-12 rounded-lg text-sm bg-[color:var(--plum)] text-white hover:bg-[color:var(--plum-2)] transition-colors">
          <CalendarDays className="h-4 w-4" strokeWidth={1.75} /> Termin
        </TerminDialog>
      </div>
    </div>
  );
};
